export default "__VITE_ASSET__CBKXqmSt__"